var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-list-item',{staticClass:"px-2",attrs:{"router-link":"","to":"/profile"}},[_c('v-list-item-avatar',{attrs:{"color":"primary"}},[(_vm.initials)?_c('span',{staticClass:"white--text"},[_vm._v(" "+_vm._s(_vm.initials)+" ")]):_c('v-icon',[_vm._v("mdi-account-circle")])],1),_c('v-list-item-title',[_vm._v(_vm._s(_vm.auth.name || 'Logged In'))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }